import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden" data-id="element-58">
      {/* Background grid */}
      <div className="absolute inset-0 bg-grid-pattern opacity-50" data-id="element-59" />

      {/* Green glow behind image */}
      <div className="absolute top-1/2 right-0 -translate-y-1/2 w-[600px] h-[600px] bg-brand-green/10 rounded-full blur-[120px] pointer-events-none" data-id="element-60" />

      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-61">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-62">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} className="max-w-2xl" data-id="element-63">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-panel border border-brand-panelBorder mb-6" data-id="element-64">
              <Zap className="w-4 h-4 text-brand-green" data-id="element-65" />
              <span className="text-xs font-mono text-brand-gray tracking-wider uppercase" data-id="element-66">
                The 7-Day Protocol
              </span>
            </div>

            <h1 className="text-5xl lg:text-7xl font-bold leading-[1.1] tracking-tight mb-6" data-id="element-67">
              Stop Staring at{' '}
              <span className="text-brand-red text-glow-red" data-id="element-68">Red Scores.</span>
              <br data-id="element-69" />
              <span className="text-brand-green text-glow-green" data-id="element-70">
                Master
              </span>{' '}
              Your Wearable Data.
            </h1>

            <p className="text-lg lg:text-xl text-brand-gray mb-10 leading-relaxed max-w-xl" data-id="element-71">
              Convert your Oura, Whoop, or Apple Watch data into a
              high-performance roadmap and hit 90%+ Readiness scores without
              buying expensive gadgets or toxic supplements.
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6" data-id="element-72">
              <Button size="lg" onClick={() => document.getElementById('offer')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-73">
                GET THE PROTOCOL
              </Button>
              <div className="flex items-center gap-2 text-sm text-brand-gray font-mono" data-id="element-74">
                <ShieldCheck className="w-4 h-4 text-brand-green" data-id="element-75" />
                <span data-id="element-76">Instant access · 100% secure</span>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2
        }} className="relative lg:ml-auto" data-id="element-77">
            <div className="relative rounded-2xl overflow-hidden border border-brand-panelBorder bg-brand-panel shadow-2xl" data-id="element-78">
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent z-10" data-id="element-79" />
              <img src="https://cdn.magicpatterns.com/uploads/tKrBAGDTYXZw5b4rbbg7uw/heylloyd-image-1779418149205.png" alt="Man holding phone with 94% recovery score" className="w-full h-auto object-cover relative z-0" data-id="element-80" />
              {/* Decorative data overlays */}
              <div className="absolute top-6 right-6 z-20 bg-black/60 backdrop-blur-md border border-white/10 rounded-lg p-3 font-mono text-xs" data-id="element-81">
                <div className="text-brand-gray mb-1" data-id="element-82">HRV BASELINE</div>
                <div className="text-brand-green text-lg" data-id="element-83">
                  84ms <span className="text-xs text-brand-green/70" data-id="element-84">↑12%</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}